export default __webpack_public_path__ + "static/media/logo-light.62ff42d9.png";